import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {cn} from '@/lib/utils'

/** La marca «opcional» va junto al rótulo, nunca en el placeholder. */
export function Campo({
  label,
  hint,
  htmlFor,
  accion,
  opcional = false,
  children,
  className,
}: {
  label: string
  hint?: ReactNode
  /** Solo para un control único; los grupos de chips no tienen a qué apuntar y llevan su `aria-label`. */
  htmlFor?: string
  accion?: ReactNode
  opcional?: boolean
  children: ReactNode
  className?: string
}) {
  const {t} = useTranslation()
  const Rotulo = htmlFor ? 'label' : 'p'
  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center justify-between gap-2">
        <Rotulo
          htmlFor={htmlFor}
          className="flex min-w-0 flex-wrap items-center gap-x-1.5 font-mono text-[10px] font-semibold tracking-[0.12em] text-muted-foreground uppercase">
          {label}
          {opcional && (
            <span className="font-sans text-[10px] font-normal tracking-normal text-muted-foreground/70 normal-case">
              {t('common.opcional')}
            </span>
          )}
        </Rotulo>
        {accion}
      </div>
      {children}
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  )
}

export function ChipOpcion({
  seleccionado,
  tone,
  className,
  ...props
}: React.ComponentProps<'button'> & {seleccionado: boolean; tone?: string}) {
  return (
    <button
      type="button"
      aria-pressed={seleccionado}
      className={cn(
        'flex min-h-12 items-center justify-center rounded-lg border px-3 text-center text-sm font-medium transition-colors',
        seleccionado
          ? tone
            ? cn(tone, 'border-transparent font-semibold shadow-button')
            : 'border-primary bg-primary text-primary-foreground font-semibold shadow-button'
          : 'border-input bg-card text-foreground hover:border-[color-mix(in_oklch,var(--input),var(--foreground)_18%)] hover:bg-secondary/50',
        className
      )}
      {...props}
    />
  )
}
